import { render, staticRenderFns } from "./UpdateHealthInformation.vue?vue&type=template&id=2e5c1844&scoped=true"
import script from "./UpdateHealthInformation.vue?vue&type=script&lang=js"
export * from "./UpdateHealthInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5c1844",
  null
  
)

export default component.exports